import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, map } from 'rxjs';
import { environment } from 'src/environments/environment';
import { SetupStatus } from 'src/app/pages/dashboard/setup-checklist/setup-checklist.component';

@Injectable({ providedIn: 'root' })
export class OnboardingApiService {
  private readonly baseUrl = environment.apiBaseUrl;

  constructor(private http: HttpClient) {}

  obterStatus(): Observable<SetupStatus> {
    return this.http
      .get<{ conteudo: SetupStatus }>(`${this.baseUrl}/api/v1/onboarding/status`)
      .pipe(map(r => r.conteudo));
  }
}
